export const Asterisk = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
    >
      <g>
        <mask
          id="mask0_15650_21851"
          style={{ maskType: 'luminance' }}
          width="80"
          height="80"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <g>
            <path fill="#fff" d="M80 0H0v80h80V0z"></path>
          </g>
        </mask>
        <g mask="url(#mask0_15650_21851)">
          <g>
            <path
              fill="#BA68C8"
              fillRule="evenodd"
              d="M42.857 0h-5.714v25.301L27.665 1.842l-5.298 2.14L32.09 28.05 13.736 9.695l-4.04 4.041 17.591 17.592-22.797-9.96-2.288 5.236 24.122 10.539H0v5.714h26.324L2.202 53.397l2.288 5.236 22.797-9.96L9.695 66.263l4.041 4.04L32.09 51.95l-9.723 24.067 5.298 2.14L37.143 54.7V80h5.714V54.699l9.478 23.459 5.298-2.14L47.91 51.95l18.354 18.354 4.04-4.04-17.591-17.592 22.797 9.96 2.288-5.236-24.122-10.539H80v-5.714H53.676l24.122-10.54-2.288-5.236-22.797 9.96 17.591-17.591-4.04-4.04L47.91 28.048l9.723-24.066-5.298-2.14L42.857 25.3V0z"
              clipRule="evenodd"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}
